export default function LogIn() {
  return <h1>LogIn</h1>;
}
